import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { store } from '../app/store'

type ProtectedLoaderOptions = {
  allowedRoles?: string[]
  /** If true, only requires authentication (any logged-in user). Skips role check. */
  authOnly?: boolean
}

export function protectedLoader(
  { request }: LoaderFunctionArgs,
  { allowedRoles = [], authOnly = false }: ProtectedLoaderOptions,
) {
  const state = store.getState()
  const userToken = state.auth.userToken
  const currentUserType = state.auth.currentUserType

  if (!userToken) {
    const params = new URLSearchParams()
    params.set('from', new URL(request.url).pathname)
    return redirect('/login?' + params.toString())
  }

  if (
    !authOnly &&
    (allowedRoles.length === 0 || !allowedRoles.includes(currentUserType))
  ) {
    return redirect('/unauthorized')
  }

  return null
}
